import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Home, DollarSign } from 'lucide-react';
export function PainPoints() {
  const stats = [{
    icon: DollarSign,
    text: 'Las mamás latinas en USA ganan 20% menos que el promedio',
    source: 'elpais.com',
    color: 'bg-red-100 text-red-600'
  }, {
    icon: TrendingUp,
    text: 'Las facturas suben 15% cada año',
    source: 'telemundo.com',
    color: 'bg-orange-100 text-orange-600'
  }, {
    icon: Home,
    text: 'Necesitas cash YA, flexible con niños. Sin oficina.',
    source: 'Realidad diaria',
    color: 'bg-blue-100 text-blue-600'
  }];
  return <section className="pt-8 pb-20 bg-[#FFF8F0]" data-id="element-157">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-158">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-159">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D1B0E] mb-6" data-id="element-160">
            😔 Tu Realidad Hoy...
          </h2>
          <p className="text-xl text-[#2D1B0E]/80 leading-relaxed italic" data-id="element-161">
            "Tu factura de luz llega atrasada. Los niños duermen. El sueldo no
            alcanza para remesas. Abres el celular..."
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-162">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-lg border border-[#E8614D]/10 hover:shadow-xl transition-shadow" data-id="element-163">
              <div className={`w-12 h-12 rounded-full ${stat.color} flex items-center justify-center mb-6`} data-id="element-164">
                <stat.icon className="w-6 h-6" data-id="element-165" />
              </div>
              <p className="text-lg font-medium text-[#2D1B0E] mb-4" data-id="element-166">
                {stat.text}
              </p>
              <p className="text-xs text-[#2D1B0E]/50 uppercase tracking-wider font-semibold" data-id="element-167">
                Fuente: {stat.source}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}